import { resolveAsFunction } from "lib/resolve-as-function"

export function idEquals(id, key = "id") {
    id = resolveAsFunction(id)
    return (props) => Object.get(props, key) === id(props)
}

export function idNotEqual(id, key = "id") {
    id = resolveAsFunction(id)
    return (props) => Object.get(props, key) !== id(props)
}
